import 'antd/dist/antd.css';

import { Layout, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import { pageView } from '../../../helpers/googleAnalytics';
import { AuthConsumer } from '../../../security/authContext';
import Environment from '../../Environment';
import GreetingUser from '../../GreetingUser';
import SideBar from '../../SideBar';

const { Content, Header } = Layout;

function ProtectedRoute({ component: Component, mediaQuerys, ...rest }) {
  return (
    <Route
      {...rest}
      render={props => {
        pageView(props.location.pathname);
        return (
          <AuthConsumer>
            {({ authenticated }) => {
              if (authenticated) {
                return (
                  <Layout style={{ height: '100vh' }}>
                    <SideBar {...props} />
                    <Layout className="site-layout">
                      <Header>
                        <Row>
                          <Environment env={process.env.REACT_APP_NODE_ENV} />
                          <GreetingUser
                            name={localStorage.getItem('name')}
                            nomeAlternado={localStorage.getItem(
                              'nameUsuarioAlternado'
                            )}
                          />
                        </Row>
                      </Header>
                      <Content>
                        <Component {...props} mediaQuerys={mediaQuerys} />
                      </Content>
                    </Layout>
                  </Layout>
                );
              }
              return <Redirect to="/" />;
            }}
          </AuthConsumer>
        );
      }}
    />
  );
}

ProtectedRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  mediaQuerys: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
    xxl: PropTypes.bool,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

ProtectedRoute.defaultProps = {
  mediaQuerys: null,
  location: {
    pathname: '/',
  },
  history: {},
};

export default ProtectedRoute;
